class ColorHelper
{

    getRandomColor = () => {
        let color = "#" + Math.floor(Math.random()*16777215).toString(16);
        const colorLn = color.length
        if (colorLn < 7) {
            let rest = 7 - colorLn;
            for (let i = 0; i < rest; i++) {
                color = color + "0";
            }

        }
        return color;
    }

}

export default new ColorHelper();